import styled from '@emotion/styled'

import { getErrorLinkStyle } from '../styles'

export const ErrorText = styled.div`
  color: ${props => props.theme.colors.error};
  padding: 0.25rem 0.5rem 0rem 0.5rem;

  a {
    ${props => getErrorLinkStyle(props.theme, false)}
  }
`
export default ErrorText
